export default "__VITE_ASSET__CxW8fJn2__"